import journalsReducer from "./reducers";
export { default as journalsTypes } from "./types";
export { default as journalsActions } from "./actions";
export { default as journalsOperations } from "./operations";
export default journalsReducer;
